import { GridColDef } from '@mui/x-data-grid'
import CellStatus, { Color } from '@/components/GokuDataGrid/CellStatus'
import CellDate from '@/components/GokuDataGrid/CellDate'
import { ResellerInvoice } from '@/modules/Reseller/types'
import { TFunction } from 'i18next'
import { Typogaphy } from 'vnetwork-ui'
import { Link } from 'react-router-dom'
import { generatePathDatacentral, paths } from '@/utils/path'

const INVOICE_STATUS_OPTIONS = (t: TFunction) => [
    {
        label: t('paid'),
        value: 'paid',
        color: 'success' as Color,
    },
    {
        label: t('waiting_confirm'),
        value: 'waiting-confirm',
        color: 'warning' as Color,
    },
    {
        label: t('approved'),
        value: 'approved',
        color: 'info' as Color,
    },
    {
        label: t('draft'),
        value: 'draft',
        color: 'default' as Color,
    },
    {
        label: t('cancelled'),
        value: 'cancelled',
        color: 'error' as Color,
    },
    {
        label: t('overdue'),
        value: 'overdue',
        color: 'error' as Color,
    },
]

const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        maximumFractionDigits: 0,
    }).format(value)
}

export const columns = (t: TFunction): GridColDef<ResellerInvoice>[] => [
    {
        field: 'invoice_id',
        headerName: t('invoice_id'),
        width: 100,
        sortable: false,
        renderCell: ({ row }) => (
            <Link
                to={generatePathDatacentral(paths.invoiceDetail, {
                    id: row.invoice_id.toString(),
                })}
                className="text-primary hover:underline font-medium"
            >
                #{row.invoice_id}
            </Link>
        ),
    },
    {
        field: 'customer_name',
        headerName: t('customer'),
        flex: 1,
        minWidth: 150,
        sortable: false,
        renderCell: ({ row }) => (
            <Link
                to={generatePathDatacentral(paths.customerDetail, {
                    id: row.customer_id.toString(),
                })}
                className="text-primary hover:underline"
            >
                {row.customer_name}
            </Link>
        ),
    },
    {
        field: 'invoice_status',
        headerName: t('status'),
        width: 140,
        sortable: false,
        renderCell: ({ row }) => {
            const status = INVOICE_STATUS_OPTIONS(t)?.find(
                (item) => item?.value === row.invoice_status
            )

            return (
                <CellStatus
                    label={status?.label || row.invoice_status || '-'}
                    color={status?.color as Color}
                    className="capitalize min-w-[80px]"
                />
            )
        },
    },
    {
        field: 'invoice_total',
        headerName: t('total'),
        width: 150,
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy className="font-semibold">
                {formatCurrency(row.invoice_total || 0)}
            </Typogaphy>
        ),
    },
    {
        field: 'due_date',
        headerName: t('due_date'),
        width: 120,
        sortable: false,
        renderCell: ({ row }) =>
            row.due_date ? (
                <CellDate date={row.due_date} scope="DD/MM/YYYY" />
            ) : (
                <Typogaphy>-</Typogaphy>
            ),
    },
    {
        field: 'created_at',
        headerName: t('created_at'),
        width: 140,
        sortable: false,
        renderCell: ({ row }) =>
            row.created_at ? (
                <CellDate date={row.created_at} />
            ) : (
                <Typogaphy>-</Typogaphy>
            ),
    },
]
